import db from '../../versa/db.js';

const clearRow = function(row)
{
	row.querySelectorAll('TD').forEach(column => column.parentNode.removeChild(column));
	// Precisa destruir eventuais campos que existam no form também
};

const appendColumn = function(row, properties)
{
	let td = document.createElement('TD');
	let input = document.createElement('INPUT');
	Object.keys(properties).forEach(key => 
	{
		if (key == 'required' && properties[key])
			input.setAttribute(key, '');
		else
			input[key] = properties[key];
	});
	td.appendChild(input);
	row.appendChild(td);
	// Precisa criar um campo no form também e vincular ao id do elemento criado
	// Atribuir algum tipo ao campo criado?
};

// Requires observer.js
export default function (...args)	// sku selector, taxons selector
{
	return {

		async actions(ev, publisher, category_id)
		{
			let company_id = this.locate('company_id').getValue();
			if (!company_id || company_id < 0 || !category_id || category_id < 0)
				return;
			let category = await db.get('categories', [company_id, Number(category_id)], 1);
			if (!category || !category.attributes)
				return;
			let sku = document.querySelector(`${args[0]} TR`);
			let taxons = document.querySelector(`${args[1]} TR`);
			if (!sku || !taxons)
				return;
			clearRow(sku);
			clearRow(taxons);
			category.attributes.forEach((attribute, index) =>
			{
				appendColumn(sku, { id: args[0].slice(1), type: 'text', size: attribute.length, title: attribute.name, required: !attribute.is_optional });
				appendColumn(taxons, { id: args[1].slice(1), type: 'text', size: 1, title: attribute.name, required: !attribute.is_optional });
				//appendColumn(sku, { id: `${args[0].slice(1)}${index}`, type: 'text', size: attribute.length, title: attribute.name, required: !attribute.is_optional });
				//appendColumn(taxons, { id: `${args[1].slice(1)}${index}`, type: 'text', size: 1, title: attribute.name, required: !attribute.is_optional });
			});
			/*
			if (this.isEmpty())
			{
				this.setValue(lot.lot_number);
				this.refresh();
			}
			let product = await db.get('products', [company_id, lot.product_id]);
			if (!product)
				return;
			let sku = this.locate(this.makeId('sku-0'));
			if (sku.isEmpty())
			{
				sku.setValue(product.sku.join(''));
				sku.refresh();
			}
			*/
		},

		/*
		getValue(default_value, _this = this)
		{
			// Ler o valor de cada um dos campos (na ordem?) e montar um array com os valores
			let x = this.safeProtoCall(default_value, _this);
console.log('get', x);
			return x;
		},

		setValue(values, _this = this)
		{
			// Jogar cada elemento do array em um dos campos do seletor, conforme o índice
			(values || []).forEach((value, index) =>
			{
				this.locate(`name_${index}`).setValue(value);
			});
		},

		checkValue(value = this.getValue())
		{
console.log('check', value);
			return this.isEmpty() || value?.every(entry => Boolean(entry));
		},

		isEmpty(value = this.getValue())
		{
console.log('empty', value);
			return !value || (value.length == 1 && value[0] == '');
		},
		*/

		/*
		format(value = this.getValue(), mask = this.display_mask)
		{
console.log('format', value);
			return (Array.isArray(value) ? value.join(`${this._separator} `) : value || '');
		},
		*/

	};
}

